import React from 'react';
import './CV.css';

const CV = () => {
  return (
    <div className="cv-container">
    <h1 className="title">My Experience</h1>
      <div className="download-section">
        <b><a href="/assets/cv.pdf" target="_blank" rel="noopener noreferrer">Download my full CV (Updated as of 2025).</a></b>
      </div>

      <div className="education-section cv-section">
        <h2 className="section-heading">Education</h2>
      
        {/* NCAT Grad */}
        <h3 className="school-title">North Carolina A&amp;T State University, College of Engineering, Greensboro, NC</h3>
        <p className="degree">Master of Science in Data Science and Engineering</p>
        
        {/* NCAT Undergrad */}
        <h3 className="school-title">North Carolina A&amp;T State University, College of Business and Economics, Greensboro, NC</h3>
        <p className="degree">Bachelor of Science in Economics</p>

        {/* College of the Albemarle */}
        <h3 className="school-title">College of the Albemearle, Elizabeth City, NC</h3>
        <p className="degree">Associate of Arts</p>

      </div>


      <div className="work-section cv-section">
      <h2 className="section-heading">Work</h2>
        
        {/* NCAT Grad */}

        <h3 className="school-title">Diem (December 2024 - August 2025)</h3>
        <p className="position">Engineering Intern</p>
        <ul>
            <li>Worked on full feature lifecycles, handling debugging and codebase updates across multiple sprint cycles in an agile startup environment</li>
            <li>Implemented production-level improvements for search functionality and user-facing platform experiences</li>
            <li>Improved CMS workflows and usability for marketing and other nontechnical team members through interface and platform logic refinements</li>
        </ul>
        <h3 className="school-title">Activision Blizzard, App UI Dev Team (June 2022 - August 2022)</h3>
        <p className="position">Front-end Development Intern</p>
        <ul>
            <li>Updated and maintained My Call of Duty website using React Native</li>
            <li>Implemented new design on My Call of Duty using React Native</li>
            <li>Conducted research on the feasibility of future Call of Duty Companion app endeavors</li>
        </ul>
      </div>
    </div>
  );
};

export default CV;
